import React from "react";
import { Card, Typography } from "@mui/material";
import CardBody from "../../../components/Card/CardBody";
import FormTextTC from "../../../components/Forms/FormTextTC.js";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

export default function Tablet() {
  return <ExitAppCard />;
}

export function ExitAppCard() {
  return (
    <Card>
      <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
        <Typography>
          <TranslationWrapper tKey={"exit_app_title"} tDefault={"Exit App"} />
        </Typography>
        <FormTextTC
          name={"custom_data.tablets.exit_pincode"}
          tKey={"custom_data.tablets.exit_pincode"}
          tDefault={"Exit pincode (empty for no pincode)"}
        />
        <FormTextTC
          name={"custom_data.exit_url"}
          tDefault={"Exit Url (e.g. mastercode)"}
          tKey={"custom_data.exit_url"}
        />
      </CardBody>
    </Card>
  );
}
